var _path, _circle, _circle2, _path2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _ellipse, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _path3, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _path4, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60504B"
    },
    d: "M523.3,868v46.8c0,48.8,55.4,50.3,55.4,4.5v-51.8L523.3,868z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.7,
    y: 889.3,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.6,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.7,
    y: 897.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.6,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.7,
    y: 906.2,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.6,
    height: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60504B"
    },
    d: "M420,868v46.8c0,48.8,55.4,50.3,55.4,4.5v-51.8L420,868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D527F"
    },
    d: "M394.4,493.8c0,66.4,0,148.9,0,228.2c0,55.8,0,110,0,155.8c56.6,0,58.8,0,99.7,0 c0-46.8,0-101.4,0-154.5c0-75.9,0-148.8,0-191.6c5.9,0,14.5,0,19.9,0c0,41.3,0,115.8,0,191.6c0,54.9,0,110.4,0,154.5 c45,0,34.6,0,91.7,0c0-43,0-97.5,0-154.5c0-79.5,0-164,0-229.5H394.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.4,
    y: 889.3,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.6,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.4,
    y: 897.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.6,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.4,
    y: 906.2,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.6,
    height: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ABD1D5"
    },
    d: "M376.9,509c0-47.3,6-116.9,31.1-167.4c8.4-16.8,18.9-31.5,32-42.5c15.7-13.2,35.3-21.2,59.4-21.2 c26.1,0,46.9,9.2,63.4,24.3c10.3,9.4,19,21.2,26.2,34.4c27.5,50.4,34.5,122.5,34.5,172.4L376.9,509L376.9,509z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 616.8,
    y1: 509.6,
    x2: 384,
    y2: 509.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 500.9,
    cy: 304.3,
    rx: 22,
    ry: 16.3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3AF9D"
    },
    d: "M843.8,326.2l17-6.8c0,0,6.1,5.5,13,11.2s-4.7,18.4-15.3,10.6C847.8,333.4,843.8,326.2,843.8,326.2z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99AFB1"
    },
    d: "M285.8,267.1l3,56.8c58.9,0.3,93.5-2.3,119.3,17.7l48.7-50.2C402.5,264.7,341.8,263.7,285.8,267.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99AFB1"
    },
    d: "M545.7,290.4l43.3,53.2c27-16.2,67.7-16.3,126.6-16.7v-56.8C659.6,266.7,616.4,259.7,545.7,290.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3AF9D"
    },
    d: "M291,273.7c-47.7,2.7-123.1,8.9-160.2,14.2c-37.1,5.3-40.1,40.1,5.3,39.5s95.2-3.5,159.7-12.1 L291,273.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3AF9D"
    },
    d: "M155.6,326.2l-17-6.8c0,0-6.1,5.5-13,11.2c-6.9,5.7,4.7,18.4,15.3,10.6 C151.6,333.4,155.6,326.2,155.6,326.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3AF9D"
    },
    d: "M709.7,318.3c64.5,8.6,113.3,11.5,158.7,12.1s42.4-34.2,5.3-39.5c-37.1-5.3-114.5-11.5-162.2-14.2 L709.7,318.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3AF9D"
    },
    d: "M489.5,211.9h20.9c0,0,4.3,67.3,5.7,90.8c-2.1,9.7-9.1,11.3-15.5,11.1c-8.2-0.2-15.9-4.7-17.1-12.5 L489.5,211.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD9B8E"
    },
    d: "M489.5,211.9h20.9c1.9,19-21.6,89.4-26.8,89.4L489.5,211.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72605A"
    },
    d: "M499,113c-27,0-89,8-56,64c24.8,42.1,88,44,110,3S549,113,499,113z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DF7977"
    },
    cx: 560.2,
    cy: 182.8,
    r: 12.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DF7977"
    },
    cx: 437.6,
    cy: 182.8,
    r: 12.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F3AF9D"
    },
    cx: 499.8,
    cy: 177.4,
    rx: 57,
    ry: 57.6
  }), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rightMiddleLip_2_",
    d: "M487.5,209.6c0.3,0,0.5,0.3,0.5,0.5s-0.3,0.5-0.5,0.5c-0.3,0-0.5-0.3-0.5-0.5 S487.3,209.6,487.5,209.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "upperLipBottomMid_1_",
    cx: 499.3,
    cy: 209.9,
    r: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipBottom1_1_",
    cx: 496.8,
    cy: 209.6,
    r: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "leftMiddleLip_2_",
    d: "M511.1,209.6c0.3,0,0.5,0.3,0.5,0.5s-0.3,0.5-0.5,0.5s-0.5-0.3-0.5-0.5S510.8,209.6,511.1,209.6z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipBottom1_1_",
    cx: 501.8,
    cy: 209.6,
    r: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DF7977",
      stroke: "#DF7977",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M488,210.1c0,0,7.7-0.1,11.3-0.1 s11.9-0.1,11.9-0.1s-6.9,2.6-11.9,2.6C494.2,212.5,488,210.1,488,210.1z"
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "lowerLipTopMid_2_",
    cx: 499.3,
    cy: 211.9,
    r: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipTop0_2_",
    cx: 496.8,
    cy: 211.4,
    r: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipTop0_2_",
    cx: 501.8,
    cy: 211.4,
    r: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DF7977"
    },
    cx: 464.1,
    cy: 196.5,
    rx: 7.8,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2C323A"
    },
    cx: 464,
    cy: 180.6,
    rx: 3.6,
    ry: 5.8
  }), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye0_1_",
    cx: 468.6,
    cy: 160.2,
    r: 0.8
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye1_1_",
    cx: 473.8,
    cy: 156.5,
    r: 0.8
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye5_1_",
    cx: 473.8,
    cy: 162.5,
    r: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye2_1_",
    cx: 480.1,
    cy: 156.5,
    r: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye3_1_",
    cx: 485.3,
    cy: 160.7,
    r: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye4_1_",
    cx: 480.1,
    cy: 161.7,
    r: 0.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2C323A"
    },
    cx: 532.8,
    cy: 179.6,
    rx: 3.6,
    ry: 5.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DF7977"
    },
    cx: 533.2,
    cy: 196.5,
    rx: 7.8,
    ry: 6.2
  }), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye0_1_",
    cx: 528.2,
    cy: 160.2,
    r: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye1_1_",
    cx: 523,
    cy: 156.5,
    r: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye5_1_",
    cx: 523,
    cy: 162.5,
    r: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye2_1_",
    cx: 516.7,
    cy: 156.5,
    r: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye3_1_",
    cx: 511.5,
    cy: 160.7,
    r: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye4_1_",
    cx: 516.7,
    cy: 161.7,
    r: 0.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C323A"
    },
    d: "M518.8,159.9c10.7-5,14.2-5,19.2,0.7C533,159.9,532.3,163.4,518.8,159.9z"
  }), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow1_1_",
    cx: 530.1,
    cy: 148.7,
    r: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow4_1_",
    cx: 506.5,
    cy: 150.8,
    r: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow3_1_",
    cx: 516.5,
    cy: 147.6,
    r: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow0_1_",
    cx: 534.1,
    cy: 151.6,
    r: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow2_1_",
    cx: 523.8,
    cy: 147.2,
    r: 0.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C323A"
    },
    d: "M478,159.9c-10.7-5-14.2-5-19.2,0.7C463.8,159.9,464.5,163.4,478,159.9z"
  }), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow1_1_",
    cx: 466.4,
    cy: 148.3,
    r: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow4_1_",
    cx: 489.7,
    cy: 151.3,
    r: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow3_1_",
    cx: 479.9,
    cy: 147.3,
    r: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow0_1_",
    cx: 462.4,
    cy: 152,
    r: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow2_1_",
    cx: 472.6,
    cy: 147.3,
    r: 0.8
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72605A"
    },
    d: "M456,138c1.9,7.7,62.3,20.7,82-3c10-12,9-22,4-25c-4.4-2.6-9-6-22,6c-1-9,1-15-16-17 C476.2,95.7,451.6,120,456,138z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C323A",
      stroke: "#2C323A",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M496.4,185.8c-1.2,0-4.6,1.6-5.8,5.2 c-0.2,1.2,0.6,5.8,6,4.1c-0.1-1-4.7-1.1-4.5-3.7C492.4,189.6,494.1,189.6,496.4,185.8z"
  }), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    id: "nose1_1_",
    cx: 497.6,
    cy: 161.2,
    r: 0.8
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    id: "nose0_1_",
    cx: 497.6,
    cy: 155.4,
    r: 0.8
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    id: "nose3_1_",
    cx: 497.6,
    cy: 173.8,
    r: 0.8
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    id: "rightNose0_1_",
    cx: 486.9,
    cy: 178.3,
    r: 0.8
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    id: "rightNose1_1_",
    cx: 492.1,
    cy: 178.3,
    r: 0.8
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    id: "nose2_1_",
    cx: 497.6,
    cy: 166.7,
    r: 0.8
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    id: "nose4_1_",
    cx: 497.6,
    cy: 179.1,
    r: 0.8
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    id: "leftNose0_1_",
    cx: 508,
    cy: 178.3,
    r: 0.8
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    id: "leftNose1_1_",
    cx: 503.2,
    cy: 178.3,
    r: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "skeleton_1_"
  }, _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    id: "rightShoulder",
    cx: 392.8,
    cy: 294.3,
    r: 8.2
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    id: "rightElbow",
    cx: 289.3,
    cy: 294.4,
    r: 8.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "rightWrist",
    transform: "matrix(0.9951 -9.853767e-02 9.853767e-02 0.9951 -29.0274 13.8698)",
    cx: 125.9,
    cy: 300.8,
    rx: 8.2,
    ry: 8.2
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    id: "rightHip",
    cx: 443.1,
    cy: 510.1,
    r: 8.2
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    id: "rightKnee",
    cx: 449.5,
    cy: 670.3,
    r: 8.2
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    id: "rightAnkle",
    cx: 449.5,
    cy: 878.3,
    r: 8.2
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    id: "leftShoulder",
    cx: 605.7,
    cy: 294.3,
    r: 8.2
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    id: "leftElbow",
    cx: 710.1,
    cy: 294,
    r: 8.2
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    id: "leftWrist",
    cx: 873.5,
    cy: 300.3,
    r: 8.2
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    id: "leftHip",
    cx: 559.5,
    cy: 509.3,
    r: 8.2
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    id: "leftKnee",
    cx: 559.5,
    cy: 670.3,
    r: 8.2
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    id: "leftAnkle",
    cx: 559.5,
    cy: 878.3,
    r: 8.2
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "392.7,294.6 443,510.4 559.4,509.6 605.6,294.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "391.7,294.6 289,294.6 125.7,300.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "607.1,294.2 710.3,294.2 873.6,300.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "443,510.4 449.4,670.6 449.4,878.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "559.4,509.6 559.4,670.6 559.4,878.6  "
  }), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye0",
    cx: 468.6,
    cy: 160.2,
    r: 0.8
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow1",
    cx: 466.4,
    cy: 148.3,
    r: 0.8
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow4",
    cx: 489.7,
    cy: 151.3,
    r: 0.8
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    id: "nose1",
    cx: 497.6,
    cy: 161.2,
    r: 0.8
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow3",
    cx: 479.9,
    cy: 147.3,
    r: 0.8
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye1",
    cx: 473.8,
    cy: 156.5,
    r: 0.8
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow0",
    cx: 462.4,
    cy: 152,
    r: 0.8
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    id: "rightBrow2",
    cx: 472.6,
    cy: 147.3,
    r: 0.8
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye5",
    cx: 473.8,
    cy: 162.5,
    r: 0.8
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye2",
    cx: 480.1,
    cy: 156.5,
    r: 0.8
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye3",
    cx: 485.3,
    cy: 160.7,
    r: 0.8
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    id: "nose0",
    cx: 497.6,
    cy: 155.4,
    r: 0.8
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    id: "nose3",
    cx: 497.6,
    cy: 173.8,
    r: 0.8
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    id: "rightNose0",
    cx: 486.9,
    cy: 178.3,
    r: 0.8
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    id: "rightMouthCorner",
    cx: 480.9,
    cy: 200.4,
    r: 0.8
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    id: "rightNose1",
    cx: 492.1,
    cy: 178.3,
    r: 0.8
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipTop0",
    cx: 487.8,
    cy: 197,
    r: 0.8
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    id: "nose2",
    cx: 497.6,
    cy: 166.7,
    r: 0.8
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    id: "nose4",
    cx: 497.6,
    cy: 179.1,
    r: 0.8
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    id: "upperLipTopMid",
    cx: 498.4,
    cy: 196.8,
    r: 0.8
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipTop1",
    cx: 494.3,
    cy: 195.9,
    r: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "rightMiddleLip",
    d: "M484.5,199.9c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8S484.1,199.9,484.5,199.9z "
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    id: "lowerLipBottomMid",
    cx: 498.4,
    cy: 210,
    r: 0.8
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    id: "upperLipBottomMid",
    cx: 498.4,
    cy: 200.4,
    r: 0.8
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    id: "lowerLipTopMid",
    cx: 498.4,
    cy: 203.5,
    r: 0.8
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    id: "rightUpperLipBottom1",
    cx: 494.5,
    cy: 199.9,
    r: 0.8
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipTop0",
    cx: 494.5,
    cy: 202.8,
    r: 0.8
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipBottom1",
    cx: 494.3,
    cy: 209.5,
    r: 0.8
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    id: "rightLowerLipBottom0",
    cx: 487.3,
    cy: 206.7,
    r: 0.8
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    id: "rightEye4",
    cx: 480.1,
    cy: 161.7,
    r: 0.8
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    id: "jawMid",
    cx: 498.4,
    cy: 235.8,
    r: 0.8
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw7",
    cx: 483.4,
    cy: 232.6,
    r: 0.8
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw6",
    cx: 473.4,
    cy: 225.9,
    r: 0.8
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw5",
    cx: 461.8,
    cy: 213.4,
    r: 0.8
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw4",
    cx: 455,
    cy: 193.4,
    r: 0.8
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw3",
    cx: 454.2,
    cy: 171.7,
    r: 0.8
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw2",
    cx: 454.2,
    cy: 162.2,
    r: 0.8
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw1",
    cx: 455,
    cy: 150.5,
    r: 0.8
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    id: "rightJaw0",
    cx: 457.5,
    cy: 141.2,
    r: 0.8
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    id: "topMid",
    cx: 498.6,
    cy: 115.1,
    r: 0.8
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    id: "leftTop0",
    cx: 518.3,
    cy: 117.6,
    r: 0.8
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    id: "leftTop1",
    cx: 530.9,
    cy: 127.1,
    r: 0.8
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye0",
    cx: 528.2,
    cy: 160.2,
    r: 0.8
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow1",
    cx: 530.1,
    cy: 148.7,
    r: 0.8
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow4",
    cx: 506.5,
    cy: 150.8,
    r: 0.8
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow3",
    cx: 516.5,
    cy: 147.6,
    r: 0.8
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye1",
    cx: 523,
    cy: 156.5,
    r: 0.8
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow0",
    cx: 534.1,
    cy: 151.6,
    r: 0.8
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    id: "leftBrow2",
    cx: 523.8,
    cy: 147.2,
    r: 0.8
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye5",
    cx: 523,
    cy: 162.5,
    r: 0.8
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye2",
    cx: 516.7,
    cy: 156.5,
    r: 0.8
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye3",
    cx: 511.5,
    cy: 160.7,
    r: 0.8
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    id: "leftNose0",
    cx: 508,
    cy: 178.3,
    r: 0.8
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    id: "leftMouthCorner",
    cx: 515.9,
    cy: 200.4,
    r: 0.8
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    id: "leftNose1",
    cx: 503.2,
    cy: 178.3,
    r: 0.8
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipTop0",
    cx: 509,
    cy: 197,
    r: 0.8
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipTop1",
    cx: 502.6,
    cy: 195.9,
    r: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "leftMiddleLip",
    d: "M512.3,199.9c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8 S511.9,199.9,512.3,199.9z"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    id: "leftUpperLipBottom1",
    cx: 502.4,
    cy: 199.9,
    r: 0.8
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipTop0",
    cx: 502.4,
    cy: 202.8,
    r: 0.8
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipBottom1",
    cx: 502.6,
    cy: 209.5,
    r: 0.8
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    id: "leftLowerLipBottom0",
    cx: 509.5,
    cy: 206.7,
    r: 0.8
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    id: "leftEye4",
    cx: 516.7,
    cy: 161.7,
    r: 0.8
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw7",
    cx: 513.2,
    cy: 233,
    r: 0.8
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw6",
    cx: 523.2,
    cy: 226.3,
    r: 0.8
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw5",
    cx: 534.8,
    cy: 213.7,
    r: 0.8
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw4",
    cx: 541.6,
    cy: 193.7,
    r: 0.8
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw3",
    cx: 542.4,
    cy: 172.1,
    r: 0.8
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw2",
    cx: 542.4,
    cy: 162.5,
    r: 0.8
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw1",
    cx: 541.6,
    cy: 150.8,
    r: 0.8
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    id: "leftJaw0",
    cx: 539.1,
    cy: 141.6,
    r: 0.8
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "498.4,115.1 478.6,117.6 466.1,127.1 457.5,141.2  455,150.5 454.2,162.2 454.2,171.7 455,193.4 461.8,213.4 473.4,225.9 483.4,232.6 498.4,235.8 513.2,233 523.2,226.3 534.8,213.7  541.6,193.7 542.4,172.1 542.4,162.5 541.6,150.8 539.1,141.6 530.9,127.1 518.3,117.6 498.4,115.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "462.4,152 466.4,148.3 472.6,147.3 479.9,147.3  489.7,151.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "468.6,160.2 473.8,156.5 480.1,156.5 485.3,160.7  480.1,161.7 473.8,162.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "486.9,178.3 492.1,178.3 497.6,179.1 497.6,173.8  497.6,166.7 497.6,161.2 497.6,155.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "533.9,151.6 529.9,148.7 523.6,147.2 516.3,147.6  506.3,150.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "528,160.2 522.7,156.5 516.4,156.5 511.3,160.7  516.4,161.7 522.7,162.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "508,178.3 503,178.3 497.6,179.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "480.9,200.4 487.8,197 494.3,195.9 498.4,196.8  502.6,195.9 509,197 515.9,200.4 509.5,206.7 502.4,209.5 498.4,210 494.3,209.5 487.3,206.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "480.9,200.4 484.5,200.7 494.5,199.9 498.4,200.4  502.4,199.9 512.3,200.7 515.9,200.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "480.9,200.4 484.5,200.7 494.5,202.8 498.4,203.6  502.4,202.8 512.3,200.7 515.9,200.4  "
  }), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    id: "rightTop0",
    cx: 478.7,
    cy: 117.6,
    r: 0.8
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    id: "rightTop1",
    cx: 466.1,
    cy: 127.1,
    r: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy);
export default __webpack_public_path__ + "static/media/boy.2e986bf3aeeb61e0fd11fe672f4e9094.svg";
export { ForwardRef as ReactComponent };